import { useEffect, useState, useMemo } from 'react'

import { isClient } from '@cred/shared/utils'

import {
  X_SMALL_BREAKPOINT,
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
} from 'common/const/screenResolutionList'

const useViewport = () => {
  const getWidth = () => (isClient ? window.innerWidth : undefined)
  const [width, setWidth] = useState(getWidth())

  useEffect(() => {
    const handleWindowResize = () => setWidth(getWidth())

    window.addEventListener('resize', handleWindowResize)
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  const xSmall = useMemo(() => width < X_SMALL_BREAKPOINT, [width])
  const isMobile = useMemo(() => width < MOBILE_BREAKPOINT, [width])
  const isTablet = useMemo(() => width >= MOBILE_BREAKPOINT && width < TABLET_BREAKPOINT, [width])
  const isDesktop = useMemo(() => width >= TABLET_BREAKPOINT, [width])

  return { width, xSmall, isMobile, isTablet, isDesktop }
}

export { useViewport }
